import styled from 'styled-components';

interface Props {
  src: string;
}

export const AvatarPreview = styled.div<Props>(({ src }) => ({
  height: 160,
  width: 160,
  borderRadius: '50%',
  backgroundImage: `url(${src})`,
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
  boxShadow: 'inset 0 2px 4px 0 hsla(0, 0%, 0%, 0.2)',
}));
